import React, { useEffect, useMemo } from 'react';

import { Container, Pagination } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import classes from './NgzCustomerCommunicationList.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { CustomerRow } from './CustomerRow/CustomerRow';
import { TitleRow } from './TitleRow/TitleRow';
import { FilterRow } from './FilterRow/FilterRow';
import { customerCommunicationStore } from '../../stores/customerCommunicationStore';
import { CustomerCommunicationPageTitle } from './CustomerCommunicationPageTitle/CustomerCommunicationPageTitle';
import { useCustomFilter } from '../../../shared/features/custom-filter';
import { EmptyList } from '../../../shared/components/ui-components';
import { getVisibleColumns } from '../../../shared/components/table-components';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import {
  COLUMN_WIDTHS,
  CUSTOMER_COMMUNICATION_COLUMN,
  ShowColumnsConfig,
} from './NgzCustomerCommunicationList.settings';

const NgzCustomerCommunicationList = observer(() => {
  const { customerList, getCustomerList, filterMethod } = customerCommunicationStore;
  const { isShowPagination, isShowPlaceholder, isSearchUsed, getPaginationProps } =
    filterMethod;
  const { isCoach, isSuperAdmin } = loggedInUserDataStore;

  useCustomFilter('customers');

  useEffect(() => {
    getCustomerList();
  }, []);

  const paginationProps = getPaginationProps();

  const showColumnsConfig = useMemo<ShowColumnsConfig>(
    () => ({
      [CUSTOMER_COMMUNICATION_COLUMN.NAME]: true,
      [CUSTOMER_COMMUNICATION_COLUMN.LOCATION]: !!isSuperAdmin,
      [CUSTOMER_COMMUNICATION_COLUMN.GROUP]: true,
      [CUSTOMER_COMMUNICATION_COLUMN.COACH]: !isCoach,
      [CUSTOMER_COMMUNICATION_COLUMN.START_DATE]: true,
      [CUSTOMER_COMMUNICATION_COLUMN.STATUS]: true,
      [CUSTOMER_COMMUNICATION_COLUMN.CUSTOM_FILTER]: true,
      [CUSTOMER_COMMUNICATION_COLUMN.ACTIONS]: true,
    }),
    [isCoach, isSuperAdmin],
  );

  const { visibleColumns, gridTemplateColumns } = getVisibleColumns({
    columnEnum: CUSTOMER_COMMUNICATION_COLUMN,
    showColumnsConfig,
    columnWidths: COLUMN_WIDTHS,
  });

  return (
    <Container>
      <CustomerCommunicationPageTitle />
      <div
        className={classes.customerTable}
        style={{ display: 'grid', gridTemplateColumns }}
      >
        <TitleRow visibleColumns={visibleColumns} />
        <FilterRow visibleColumns={visibleColumns} />
        {customerList.map((userInfo) => (
          <CustomerRow
            userInfo={userInfo}
            key={userInfo.id}
            visibleColumns={visibleColumns}
          />
        ))}
      </div>
      {isShowPagination && <Pagination {...paginationProps} />}
      <EmptyList
        show={isShowPlaceholder}
        isSearch={isSearchUsed}
        description="There are no customers"
      />
    </Container>
  );
});

angularizeWithProviders(NgzCustomerCommunicationList, 'ngzCustomerCommunicationList', {});
